<mat-dialog-content>
  <h3>{{'EXAM_UNLOCK_DIALOG.TITLE' | translate}}</h3>
  <h4>{{'EXAM_UNLOCK_DIALOG.INTERRUPTIONS' | translate}} @if ((numberOfAttempts | async) !== 0) {
    {{numberOfAttempts | async}}
  }</h4>
  <div class="timerCounter" [class.red-text]="isRedColor()">{{ formattedTime() }}</div>
  <div class="options">
    <mat-button-toggle-group name="dlgOpts" [(value)]="dlgChoice">
      <mat-button-toggle [value]="opts.Unlock">{{'EXAM_UNLOCK_DIALOG.UNLOCK_TITLE' | translate}}</mat-button-toggle>
      <mat-button-toggle [value]="opts.Extend">{{'EXAM_UNLOCK_DIALOG.EXTEND_TITLE' | translate}}</mat-button-toggle>
      <mat-button-toggle [value]="opts.Submit">{{'EXAM_UNLOCK_DIALOG.SUBMIT_TITLE' | translate}}</mat-button-toggle>
    </mat-button-toggle-group>
  </div>

  <div class="container">
    <div class="inputs-wrap">
      @if (dlgChoice === opts.Extend) {
        <div>
          <label for="extendTime">{{'EXAM_UNLOCK_DIALOG.EXTEND_TIME' | translate}}</label>
          <input type="number" id="extendTime" name="extendTime" [(ngModel)]="extendTime" min="0" max="60" step="5">
          <span class="minutes">{{'EXAM_UNLOCK_DIALOG.MINUTES_SHORTHAND' | translate}}</span>
        </div>
      }
      @if (dlgChoice !== opts.Submit) {
        <div class="password_container">
          <label for="code">{{'EXAM_UNLOCK_DIALOG.CODE' | translate}} *</label>
          <input type="text" class="numeric-password" id="code" name="code" autocomplete="off"
            onCopy="return false;" onCut="return false;" [(ngModel)]="enteredCode">
        </div>
      }
      @else {
        <mat-checkbox color="primary" [checked]="isSubmitConfirmed" (change)="confirmSubmit($event.checked)">
        {{'EXAM_UNLOCK_DIALOG.CONFIRMATION_MESSAGE' | translate}}</mat-checkbox>
      }
      <div class="password_container">
        <input type="text" placeholder="{{'EXAM_UNLOCK_DIALOG.COMMENT' | translate}} *" [(ngModel)]="cause" #causeInput="ngModel" required>
      </div>
      @if (!areRequiredFieldsFilled()) {
        <div class="required" [ngClass]="submitAttempted ? 'red-text' : '' ">
          <i class="fa fa-asterisk fa-xs required"></i>
          <span> {{ "EXAM_UNLOCK_DIALOG.EMPTY_FIELD" | translate }}</span>
        </div>
      }
    </div>
    <mat-dialog-actions align="center">
      <div (click)="submitAttempted = true;">
        @if (dlgChoice !== opts.Submit) {
          <button #unlockOrExtendButton mat-raised-button color="primary" [disabled]="!areRequiredFieldsFilled() && !testMode"
          (click)="unlockOrExtend()">
          {{ (dlgChoice === opts.Unlock ? 'EXAM_UNLOCK_DIALOG.CONTINUE' : 'EXAM_UNLOCK_DIALOG.EXTEND_EXAM') | translate}}
        </button>
        }
        @if (dlgChoice === opts.Submit) {
          <button mat-raised-button color="warn" [disabled]="!areRequiredFieldsFilled()"
          (click)="submit()">
          {{'EXAM_UNLOCK_DIALOG.SUBMIT' | translate}}
        </button>
        }
      </div>
    </mat-dialog-actions>
  </div>
</mat-dialog-content>
